/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../../types";

export const richBrownsTheme: OrganizationTheme = {
  id: "rich-browns",
  name: "Rich Browns",
  description: "Deep, sophisticated palette with burgundy and chocolate tones",
  recommendedFor: [
    "High-End Residential",
    "Luxury Renovations",
    "Architecture",
    "Custom Cabinetry",
  ],

  colors: {
    primary: {
      name: "Burgundy Wine",
      hex: "#3C1518",
      hsl: "358 42% 16%",
      rgb: [60, 21, 24],
    },
    primaryForeground: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    secondary: {
      name: "Copper",
      hex: "#D58936",
      hsl: "33 66% 53%",
      rgb: [213, 137, 54],
    },
    secondaryForeground: {
      name: "Burgundy Wine",
      hex: "#3C1518",
      hsl: "358 42% 16%",
      rgb: [60, 21, 24],
    },
    muted: {
      name: "Light Gray",
      hex: "#F5F5F5",
      hsl: "0 0% 96%",
      rgb: [245, 245, 245],
    },
    mutedForeground: {
      name: "Medium Gray",
      hex: "#666666",
      hsl: "0 0% 40%",
      rgb: [102, 102, 102],
    },
    card: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    cardForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    background: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    foreground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
  },

  cssVariables: {
    "--primary": "358 42% 16%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "33 66% 53%",
    "--secondary-foreground": "358 42% 16%",
    "--muted": "0 0% 96%",
    "--muted-foreground": "0 0% 40%",
    "--card": "0 0% 100%",
    "--card-foreground": "0 0% 12%",
    "--background": "0 0% 100%",
    "--foreground": "0 0% 12%",
    // Semantic colors — deep, rich tones alongside burgundy/copper
    "--success": "148 50% 38%",
    "--success-foreground": "0 0% 98%",
    "--warning": "30 72% 48%",
    "--warning-foreground": "0 0% 12%",
    "--error": "355 65% 42%",
    "--error-foreground": "0 0% 98%",
    "--info": "218 50% 46%",
    "--info-foreground": "0 0% 98%",
    "--destructive": "355 65% 42%",
    "--destructive-foreground": "0 0% 98%",
    // Sidebar / warm surface — subtle tint of secondary hue
    "--background-warm": "33 20% 98%",
    "--background-warm-alt": "33 15% 96%",
    // Extended palette — rich jewel tones complementing burgundy/copper
    "--palette-violet": "275 50% 42%",
    "--palette-teal": "172 50% 35%",
    "--palette-pink": "330 55% 45%",
    "--palette-orange": "20 75% 50%",
    "--palette-sky": "205 55% 40%",
  },
};
